'use es6';

import { OrderedSet } from 'immutable';
import { createSelector } from 'reselect';
import GoodSubTypes from '../constants/GoodSubTypes';
import GoodSubTypeGroups from '../constants/GoodSubTypeGroups';
import SystemPageSubTypes from '../constants/SystemPageSubTypes';
import { getAlphaSortedArrOfTextValPairsForSelect } from './utils';
import { getCategoryOptionText } from './langUtils';

var getAll = function getAll() {
  return [{
    item: GoodSubTypes.ALL,
    chevron: false
  }, {
    item: GoodSubTypes.CMS_THEME,
    chevron: true
  }, {
    item: GoodSubTypeGroups.TEMPLATES,
    chevron: true
  }, {
    item: GoodSubTypes.CUSTOM_MODULE,
    chevron: true
  }].filter(Boolean);
};

var systemTemplateOptions = OrderedSet([SystemPageSubTypes.CONTENT_SEARCH_RESULTS, SystemPageSubTypes.ERROR_PAGE, SystemPageSubTypes.PASSWORD_PAGE, SystemPageSubTypes.SUBSCRIPTION_PREFERENCES, SystemPageSubTypes.UNSUBSCRIBE_CONFIRMATION, SystemPageSubTypes.UNSUBSCRIBE_SIMPLE]);
export var templateOptions = OrderedSet([GoodSubTypes.EMAIL_TEMPLATES, GoodSubTypes.BLOG_TEMPLATES, GoodSubTypes.LANDING_PAGES, GoodSubTypes.SITE_PAGES, GoodSubTypeGroups.SYSTEM_PAGE_TEMPLATES, GoodSubTypes.PACKS]);
var getTemplateOptions = createSelector([function () {
  return templateOptions;
}], function (options) {
  return getAlphaSortedArrOfTextValPairsForSelect(options, getCategoryOptionText).map(function (option) {
    if (option.value === GoodSubTypeGroups.SYSTEM_PAGE_TEMPLATES) {
      return Object.assign({}, option, {
        options: getAlphaSortedArrOfTextValPairsForSelect(systemTemplateOptions.toArray(), getCategoryOptionText)
      });
    }

    return option;
  });
});
var moduleOptions = OrderedSet([GoodSubTypes.CUSTOM_MODULE]);
var themeOptions = OrderedSet([GoodSubTypes.CMS_THEME]);
export var isMainCategory = function isMainCategory(categoryFilter) {
  return categoryFilter === GoodSubTypes.ALL || categoryFilter === GoodSubTypeGroups.TEMPLATES || categoryFilter === GoodSubTypes.CUSTOM_MODULE || categoryFilter === GoodSubTypes.CMS_THEME;
};
export var getParentCategory = function getParentCategory(categoryFilter) {
  if (templateOptions.has(categoryFilter) || systemTemplateOptions.has(categoryFilter)) {
    return GoodSubTypeGroups.TEMPLATES;
  } else if (moduleOptions.has(categoryFilter)) {
    return GoodSubTypes.CUSTOM_MODULE;
  } else if (themeOptions.has(categoryFilter)) {
    return GoodSubTypes.CMS_THEME;
  }

  return null;
};
export var getCategoryMenuOptions = function getCategoryMenuOptions(categoryFilter) {
  if (categoryFilter === GoodSubTypes.ALL) {
    return getAll();
  } else if (categoryFilter === GoodSubTypeGroups.TEMPLATES || templateOptions.has(categoryFilter) || systemTemplateOptions.has(categoryFilter)) {
    return {
      options: getTemplateOptions(),
      parent: GoodSubTypeGroups.TEMPLATES
    };
  } else if (themeOptions.has(categoryFilter)) {
    var themeParent = GoodSubTypes.CMS_THEME;
    return {
      options: themeOptions.subtract([themeParent]),
      parent: themeParent
    };
  } else if (moduleOptions.has(categoryFilter)) {
    var moduleParent = GoodSubTypes.CUSTOM_MODULE;
    return {
      options: moduleOptions.subtract([moduleParent]),
      parent: moduleParent
    };
  }

  return new OrderedSet();
};